// extracted by mini-css-extract-plugin
export var acitonButtons = "_f9-0";
export var additionalIcon = "_f9-f";
export var block = "_f9-1";
export var blockContent = "_f9-7";
export var blockDescription = "_f9-8";
export var blockIcon = "_f9-9";
export var blockTitle = "_f9-6";
export var border = "_f9-a";
export var center = "_f9-l";
export var edge = "_f9-b";
export var edgeLabel = "_f9-c";
export var edgePath = "_f9-d";
export var error = "_f9-e";
export var flowchart = "_f9-g";
export var flowchartContent = "_f9-h";
export var highlighted = "_f9-3";
export var hover = "_f9-4";
export var icon = "_f9-i";
export var left = "_f9-m";
export var navButton = "_f9-j";
export var navButtons = "_f9-k";
export var right = "_f9-n";
export var selected = "_f9-2";
export var small = "_f9-5";